import React from "react";
import "./Welcome";
import { Fade } from "react-reveal";
import FullStackImg from "./FullStackImg";
import CloudInfraImg from "./CloudInfraImg";
import { t } from "i18next";
import { style } from "glamor";
import { useHistory } from "react-router-dom";

function GetSkillSvg(props) {
  if (props.fileName === "FullStackImg")
    return <FullStackImg theme={props.theme} />;
  else if (props.fileName === "CloudInfraImg")
    return <CloudInfraImg theme={props.theme} />;
  // return <DesignImg theme={props.theme} />;
}

function WelcomeSection(props) {
  const theme = props.theme;
  const history = useHistory();
  const styles = style({
    backgroundColor: `${theme.accentBright}`,
    ":hover": {
      boxShadow: `0 5px 15px ${theme.accentBright}`,
    },
  });
  return (
    <div>
      <div className="skills-main-div">
        <Fade left duration={2000}>
          <div className="skills-image-div">
            <GetSkillSvg fileName="FullStackImg" theme={theme} />
          </div>
        </Fade>

        <div className="skills-text-div">
          <Fade right duration={2000}>
            <div>
              <p
                className="subTitle skills-text"
                style={{ color: theme.secondaryText }}
              >
                {t("sections.home.welcome-to.content")}

              </p>
              <div className="portfolio-repo-btn-div">
                <button
                  {...styles}
                  className="button"
                  onClick={() => {
                    history.push("/san-gabriel");
                  }}
                >
                  {t("buttons.about-us")}
                </button>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </div>
  );
}

export default WelcomeSection;
